export default [
  {
    path: '/clientes',
    name: 'app-admin-cliente',
    component: () => import('@/views/apps/clientes/clientes-list/ClientesList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Clientes',
      action: 'read',
      resource: 'CLIENTE_B2C',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Clientes',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-cliente/:id?',
    name: 'app-admin-add-cliente',
    component: () => import('@/views/apps/clientes/clientes-add/ClienteAdd.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Clientes',
      action: 'update',
      resource: 'CLIENTE_B2C',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar Clientes',
          active: false,
          to: {
            name: 'app-admin-cliente',
          },
        },
        {
          text: 'Adicionar Cliente',
          active: true,
        },
      ],
    },
  },
  {
    path: '/visualizar-cliente/:id?',
    name: 'app-admin-view-cliente',
    component: () => import('@/views/apps/clientes/clientes-view/UsersView.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Clientes',
      action: 'read',
      resource: 'CLIENTE_B2C',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar Clientes',
          active: false,
          to: {
            name: 'app-admin-cliente',
          },
        },
        {
          text: 'Visualizar Cliente',
          active: true,
        },
      ],
    },
  },
  {
    path: '/edit-cliente/:id?',
    name: 'app-admin-edit-cliente',
    component: () => import('@/views/apps/clientes/clientes-edit/ClienteEdit.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Clientes',
      action: 'update',
      resource: 'CLIENTE_B2C',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar Clientes',
          active: false,
          to: {
            name: 'app-admin-cliente',
          },
        },
        {
          text: 'Editar Cliente',
          active: true,
        },
      ],
    },
  },
]
